
// Operations Displays
export const COMBINED_WIND_SOLAR_SUFFIX: string = '/WindSolar/GetCombined';
export const SCHEDULED_INTERCHANGE_SUFFIX: string = '/Interchange/GetNsi/MISOFiveMinute';
export const ACTUAL_INTERCHANGE_SUFFIX: string = '/Interchange/GetNai/Imports';
export const FIRST_TIER_SCHEDULED_SUFFIX: string = '/Interchange/GetNsi/FiveMinute';
export const FUEL_MIX_SUFFIX: string = '/FuelMix';
export const CSAT_PAPI_SUFFIX: string = '/CsatSupplyDemand';
export const CSAT_NET_UNCERTAINTY_SUFFIX: string = '/CsatNetUncertainty';
export const CSAT_NEXT_DAY_SHORT_TERM_RESERVE_REQUIREMENT_SUFFIX: string = '/CsatNextDayShortTermReserveRequirement';
export const RDT_SUFFIX: string = '/RegionalDirectionalTransfer';
export const GEN_OUT_SUFFIX: string = '/GenerationOutages/GetGenerationOutagesPlusMinusFiveDays';
export const REAL_TIME_TOTAL_SUFFIX: string = '/RealTimeTotalLoad';
export const ACE_SUFFIX: string = '/Ace';
export const REAL_TIME_RESERVE_MARGIN_SUFFIX: string = '/CsatRealTimeReserveMargin';

//Market Displays
export const LMP_CONSOLIDATED_TABLE_SUFFIX: string = '/MarketPricing/GetLmpConsolidatedTable';
export const EXANTE_LMP_SUFFIX: string = '/MarketPricing/GetExAnteLmp';
export const ANCILLARY_SERVICES_MCP_SUFFIX: string = "/MarketPricing/GetAncillaryServicesMcp";
export const REALTIME_BINDING_CONSTRAINTS_SUFFIX: string = "/BindingConstraints/RealTime";
export const SUBREGIONAL_POWER_BALANCE_BINDING_CONSTRAINTS_SUFFIX: string = "/BindingConstraints/SubRegional";
export const RESERVE_PRODUCTS_BINDING_CONSTRAINTS_SUFFIX: string = "/BindingConstraints/Reserve";
export const COORDINATED_TRANSACTION_SCHEDULING_SUFFIX: string = "/CoordinatedTransactionScheduling";
export const REAL_TIME_RSG_COMMITMENTS_SUFFIX: string = "/RealTimeRSGCommitments";

// Common Constants
export const DESCRIPTION_MESSAGE: string = 'description';
export const DOWNLOAD_MESSAGE: string = 'download';
export const POPOUT_MESSAGE: string = 'popout';

// Special Chart Messages
export const STR_REQ_MESSAGE: string = 'STR requirement overridden to high with projected system conditions to be at Capacity Advisory or above per EOP-002';
export const STR_REQ_FOOTER_LINK: string = 'https://www.misoenergy.org/engage/committees/market-subcommittee';
